/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{getBoundingBox as t,computeBBox as o,getTransformMatrix as r}from"../../symbols/support/svgUtils.js";function n(o){return t(o)}function s(t){return o(t)}function u(t,o,n,s,u,e,i,a,f){return r(t,o,n,s,u,e,i,a,f)}export{s as computeBBox,n as getBoundingBox,u as getTransformMatrix};
